export const cities = [
  "Ağdam",
  "Ağdaş",
  "Ağcabədi",
  "Ağstafa",
  "Ağsu",
  "Astara",
  "Babək",
  "Bakı",
  "Balakən",
  "Bərdə",
  "Beyləqan",
  "Biləsuvar",
  "Daşkəsən",
  "Füzuli",
  "Gədəbəy",
  "Gəncə",
  "Goranboy",
  "Göyçay",
  "Göygöl",
  "Hacıqabul",
  "İmişli",
  "İsmayıllı",
  "Cəbrayıl",
  "Culfa",
  "Kəlbəcər",
  "Xaçmaz",
  "Xankəndi",
  "Xocavənd",
  "Xırdalan",
  "Kürdəmir",
  "Lənkəran",
  "Lerik",
  "Masallı",
  "Mingəçevir",
  "Naxçıvan",
  "Naftalan",
  "Neftçala",
  "Oğuz",
  "Ordubad",
  "Qəbələ",
  "Qax",
  "Qazax",
  "Quba",
  "Qubadlı",
  "Qusar",
  "Saatlı",
  "Sabirabad",
  "Şabran",
  "Şahbuz",
  "Şəki",
  "Şamaxı",
  "Şəmkir",
  "Şərur",
  "Şirvan",
  "Siyəzən",
  "Şuşa",
  "Sumqayıt",
  "Tərtər",
  "Tovuz",
  "Ucar",
  "Yardımlı",
  "Yevlax",
  "Zaqatala",
  "Zərdab",
  "Zəngilan"
];
